import {
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import { useAuth } from '../../AuthContext';
import { Link } from 'react-router-dom';

// const rounds = [
//   { course: 'Arrowhead', players: ['Brian', 'Cooper', 'Dean'], holes: 18 },
//   { course: 'TPC Sawgrass', players: ['Brian', 'Cooper', 'Dean'], holes: 18 },
//   { course: 'Practice', players: ['Brian'], holes: 18 }
// ];
export default function Rounds() {
  const auth = useAuth();
  const [rounds, setRounds] = useState([]);

  const fetchRounds = async () => {
    const res = await auth.request('/api/stats/rounds');
    console.log(res.data);
    setRounds(res.data.rounds);
  }

  useEffect(() => {
    fetchRounds();
  }, []);

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Rounds
      </Typography>

      <List>
        
      {rounds.map(round => (
        <ListItemButton key={round._id} component={Link} to={`/account/round/${round._id}`}>
          <ListItemIcon>
            <GolfCourseIcon />
          </ListItemIcon>
          <ListItemText primary={round.course} secondary={round.players.join(', ')} />
        </ListItemButton>
      ))}
      </List>
    </Box>
  );
}